import { fetchDelete, fetchGet, fetchPost, fetchPut } from '.';
import { constructQueryString } from '../utils/constructQueryString';

export const fetchProjects = async (options = {}) => {
  const queryString = constructQueryString(options);
  return await fetchGet(`/project/${queryString}`);
};

export const fetchSingleProjects = async ({ queryKey }) => {
  return await fetchGet(`/project/${queryKey[1]}`);
};

export const createProject = async (body) => {
  return await fetchPost('/project', body);
};

export const updateProject = async (uuid, body) => {
  return await fetchPut(`/project/${uuid}`, body);
};

export const deleteProject = async (uuid) => {
  return await fetchDelete(`/project/${uuid}`);
};

export const projectInspectors = async ({ queryKey }) => {
  return await fetchGet(`/project/projectInspectors/${queryKey[1]}`);
};
